import container from '../container/container';
import $ from 'jquery';
import transit from 'jquery.transit';


const scroll = (function () {

    var publicVars = {};

    var privateVars = {
        name: 'scroll',

        disabled: new Map(),

        animatedElements: new Map(),

        tempAllowSection: '',

        disableAll: false
    };


    var privateMethods = {
        prepareObj: function (options) {

            publicVars = $.extend(true, publicVars, options);

            privateMethods.startup();
            privateMethods.bind();

        },
        startup: function () {

        },
        bind: function () {
            container.msg(privateVars.name, 'module started');

            $(window).scroll(function () {

                var ticking = false;

                if (!ticking) {
                    window.requestAnimationFrame(function () {
                        try {
                            privateMethods.handleCurrentScrollPosition();
                        } catch(e) {
                            container.msg(privateVars.name + ' scroll element error');
                        }
                        ticking = false;
                    });
                }
                ticking = true;

            });

            $(window).resize(function () {
                privateMethods.handleResizeTasks();
                privateMethods.handleCurrentScrollPosition();

                setTimeout(() => {
                    privateMethods.handleResizeTasks();
                }, 500);

            });

            $(window).on('orientationchange', function () {
                privateMethods.handleResizeTasks();
                privateMethods.handleCurrentScrollPosition();

                setTimeout(() => {
                    privateMethods.handleResizeTasks();
                }, 500);
            });
        },

        handleResizeTasks: () => {
            // container.msg(privateVars.name, 'resize tasks');

            privateVars.animatedElements.forEach((data) => {
                if(data.options && data.options.dynamicPosHeight) {
                    const posAndHeight = privateMethods.getPosAndHeightForSelector(data.selector);
                    data.rect = posAndHeight.rect;
                    data.offset = posAndHeight.offset;
                }
            });
        },

        handleCurrentScrollPosition: () => {

            if ($('body').hasClass('body-desktop') && $(window).outerWidth() > 1024 && !privateVars.disableAll) {

                const systemCurrentScroll = $(document).scrollTop();
                const scrollPlusWindowHeight = $(window).height() + systemCurrentScroll;

                privateVars.animatedElements.forEach((data) => {
                    privateMethods.handleElementVisible(
                        data, systemCurrentScroll, scrollPlusWindowHeight,function () {
                            $(data.selector).removeClass('animate__animated');
                            $(data.selector).removeClass(data.cls);
                            $(data.selector).css({ visibility: 'hidden'});
                            setTimeout(() => {
                                privateVars.disabled.set(data.selector, 0)
                            }, 300);
                        }, function () {
                            $(data.selector).addClass('animate__animated');
                            $(data.selector).addClass(data.cls);
                            $(data.selector).css({ visibility: 'visible'});
                            setTimeout(() => {
                                privateVars.disabled.set(data.selector, 0)
                            }, 300);
                        });
                });
            } else if(($('body').hasClass('body-desktop') && $(window).outerWidth() <= 1024) || privateVars.disableAll) {
                privateVars.animatedElements.forEach((data) => {
                    $(data.selector).addClass('animate__animated');
                    $(data.selector).addClass(data.cls);
                    $(data.selector).css({ visibility: 'visible'});
                });
            }
        },

        handleElementVisible: (item, systemCurrentScroll, scrollPlusWindowHeight, callbackOut, callbackIn) => {

            if($(item.selector).length === 0) {
                return;
            }

            if ((!privateVars.disabled.has(item.selector)
                    || privateVars.disabled.get(item.selector) !== 1)
                && (privateVars.tempAllowSection === '' || privateVars.tempAllowSection === item.section)) {

                let targetPos, rect = null;

                if(item.options && item.options.dynamicPosHeight) {
                    targetPos = item.offset;
                    rect = item.rect;
                } else {
                    targetPos = $(item.selector).offset();
                    rect = $(item.selector)[0].getBoundingClientRect();
                }

                let fixedHeaderHeight = 0;
                if(publicVars.fixedHeader) {
                    fixedHeaderHeight = $(publicVars.cssId.headerCls).outerHeight();
                }

                if(publicVars.fixedHeader && (targetPos.top - systemCurrentScroll + rect.height) < fixedHeaderHeight && (targetPos.top - systemCurrentScroll + rect.height) > 0) {
                    if (typeof callbackOut === 'function') {
                        callbackOut();
                        //privateVars.disabled.set(item.selector, 1);
                    }
                } else if (targetPos.top < scrollPlusWindowHeight &&
                    (scrollPlusWindowHeight < (targetPos.top + rect.height)
                        || systemCurrentScroll < (targetPos.top + rect.height))
                ) {
                    if (typeof callbackIn === 'function') {
                        callbackIn();
                        privateVars.disabled.set(item.selector, 1);
                    }
                } else {
                    if (typeof callbackOut === 'function') {
                        callbackOut();
                        //privateVars.disabled.set(item.selector, 1);
                    }
                }
            } else if(($('body').hasClass('body-desktop') && $(window).outerWidth() <= 1024) || privateVars.disableAll) {
                privateVars.animatedElements.forEach((data) => {
                    $(data.selector).addClass('animate__animated');
                    $(data.selector).addClass(data.cls);
                    $(data.selector).css({ visibility: 'visible'});
                });
            }
        },

        registerAnimatedElement: function (selector, cls, section, options) {

            let rect, offset = null;

            if(options && options.dynamicPosHeight) {
                const posAndHeight = privateMethods.getPosAndHeightForSelector(selector);
                rect = posAndHeight.rect;
                offset = posAndHeight.offset;
            }

            privateVars.animatedElements.set(selector, {
                selector: selector,
                cls: cls,
                section: section,
                options: options,
                rect: rect,
                offset: offset
            })
        },

        getPosAndHeightForSelector: function(selector) {

            $(selector).removeClass('animate__animated');

            let rect, offset = null;

            try {
                rect = $(selector)[0].getBoundingClientRect();
                offset = $(selector).offset();
            } catch(e) {
                container.msg(privateVars.name, 'selector error' + selector);
            }

            $(selector).addClass('animate__animated');

            return {
                rect,
                offset
            }
        },

        unregisterAnimatedElement: function (selector) {
            privateVars.animatedElements.delete(selector);
        },

        disable: function(allowSection) {
            privateVars.tempAllowSection = allowSection;
        },

        enable: function() {
            privateVars.tempAllowSection = '';
        }


    };


    var publicObj = {
        init: function (options) {
            privateMethods.prepareObj(options);
        },

        handleCurrentScrollPosition: function () {
            privateMethods.handleCurrentScrollPosition();
        },

        refreshScroll: function() {
            privateMethods.handleResizeTasks();
            privateMethods.handleCurrentScrollPosition();
        },

        registerAnimatedElement: function (selector, cls, section, options) {
            privateMethods.registerAnimatedElement(selector, cls, section, options);
        },

        unregisterAnimatedElement: function (selector) {
            privateMethods.unregisterAnimatedElement(selector);
        },

        disable: function(allowSection) {
            privateMethods.disable(allowSection);
        },

        disableAll: function () {
            privateVars.disableAll = true;
        },

        enable: function () {
            privateMethods.enable();
        },

        enableAll: function () {
            privateVars.disableAll = false;
        }

    }

    return publicObj;
})();

export default scroll;

/*
 ---
 ---
 scroll.registerAnimatedElement('.some-class', 'fadeIn', {});
 ---
 */